import template from '../../templates/settings/TaxSettings.ejs';
import FormView from 'commons/views/Form';
import modal from 'helpers/modal';
import loader from 'helpers/loader';
import Address from 'newModels/address.js';

module.exports = FormView.extend({
    events: function() {
        return Object.assign({}, FormView.prototype.events());
    },

    initialize: function(options = {}) {
        this.options = Object.assign({template}, options);

        this.options.templateExtra = Object.assign(
            {
                states: Address.getStatesList(),
                idTypes: [
                    {code: 'BRN', name: 'Business Registration Number'},
                    {code: 'NRIC', name: 'MyKad'},
                    {code: 'PASSPORT', name: 'Passport'}
                ]
            },
            this.options.templateExtra || {}
        );

        this.model.validationError = false;

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        FormView.prototype.bindHandlers.apply(this, arguments);
        return this;
    },

    unbindHandlers: function() {
        FormView.prototype.unbindHandlers.apply(this, arguments);
        return this;
    },

    render: function() {
        FormView.prototype.render.apply(this, arguments);
        this.markMandatoryFields((new Address()).constraints());
        return this;
    },

    cancel: function(ev) {
        ev.preventDefault();

        const $button    = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.fetch()
            .then(() => this.render())
            .finally(() => stopLoader());
    },

    dirty: function() {
        return this.model.dirty();
    },

    isConsentGiven: function() {
        return this.model.isConsentGiven();
    },

    save: function(ev) {
        ev.preventDefault();

        if (!this.model.isValid()) {
            this.invalid(this.model, {errors: this.model.validationError});
            return;
        }

        if (!$('.js-taxSettingsConsent').is(':checked')) {
            modal.warning({text: 'Please confirm that provided tax information is correct'});
            return;
        }

        const $button = this.$(ev.currentTarget);

        let validationFailed = false;
        if (!this.model.wasValid() || !this.model.isValid()) {
            this.invalid(this.model, this.model.validationError);
            validationFailed = true;
        }
        if (validationFailed) {
            /* If either of the required models failed validation, bail out
             */
            return;
        }

        const stopLoader = loader.startFullScreen($button);

        this.model.save()
            .then(() => this.model.fetch())
            .then(() => {
                this.setModel(this.model);
                modal.showAlertSuccess('Your changes have been saved');
            })
            .catch(err => modal.error({text: err, confirmButtonText: 'OK', callback: () => {}}))
            .finally(() => stopLoader());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/TaxSettings.js